import axiosV1 from "@/plugins/axios/configV1";

export default {
    getWarranties(params) {
        return axiosV1.get("warranty", { params });
    },
    getWarranty(id = null) {
        return axiosV1.get(`warranty/view/${id}`);
    },
    approveWarranty(payload = {}) {
        let formData = new FormData();
        for (const key in payload) {
            formData.append(key, payload[key] ? payload[key] : "");
        }
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return axiosV1.post("warranty/approve", formData);
    },
    rejectWarranty(...payload) {
        return axiosV1.post("warranty/decline", ...payload);
    },
    exportExcel(params) {
        return axiosV1.get("warranty/export", { params });
    },
    updateContractNumber(id = null, ...payload) {
        return axiosV1.post(
            `warranty/update/contract-number/${id}`,
            ...payload
        );
    },
    updateContractYears(id = null, ...payload) {
        return axiosV1.post(`warranty/update/contract-years/${id}`, ...payload); // pending
    },
    updateContractDocument(id = null, payload) {
        let formData = new FormData();
        for (const key in payload) {
            formData.append(key, payload[key] ? payload[key] : "");
        }
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return axiosV1.post(`warranty/update/contract/${id}`, formData);
    },
    updateWarrantyEnd(id = null, ...payload) {
        return axiosV1.post(`warranty/update/end-date/${id}`, ...payload);
    },
    updateWarrantyStart(id = null, ...payload) {
        return axiosV1.post(`warranty/update/start-date/${id}`, ...payload);
    },
    updateWarrantyEnd(id = null, ...payload) {
        return axiosV1.post(`warranty/update/end-date/${id}`, ...payload);
    },
    addWarranty(payload) {
        let formData = new FormData();
        for (const key in payload) {
            formData.append(key, payload[key] ? payload[key] : "");
        }
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return axiosV1.post("warranty/add", formData);
    },
    getRequestNumber() {
        return axiosV1.get("warranty/fetch/request-number");
    },
    getStores() {
        return axiosV1.get("fetch/stores");
    },
    getCustomers() {
        return axiosV1.get("fetch/customers");
    },
    getCustomerProducts(id = null) {
        return axiosV1.get(`fetch/customer/${id}/products`);
    },
    getProductPackages(id = null) {
        return axiosV1.get(`fetch/product/${id}/packages`);
    },
    importWarranty(file = null) {
        let formData = new FormData();
        formData.append("file", file);
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return axiosV1.post("warranty/import", formData);
    },
    importServiceEntries(file = null) {
        let formData = new FormData();
        formData.append("file", file);
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return axiosV1.post("warranty/import/service-history", formData);
    },

    updateServiceHistory(
        id = null,
        onsite = [],
        pickUp = [],
        isOnsite = false
    ) {
        let formData = new FormData();
        if (isOnsite) {
            for (const key in onsite) {
                if (
                    onsite[key]["id"] ||
                    (onsite[key]["service_order_number"] &&
                        onsite[key]["date_completed"])
                ) {
                    formData.append(
                        [`onsite[${key}][service_order_number]`],
                        onsite[key]["service_order_number"]
                    );
                    formData.append(
                        [`onsite[${key}][date_completed]`],
                        onsite[key]["date_completed"]
                    );
                    formData.append(
                        [`onsite[${key}][remarks]`],
                        onsite[key]["remarks"]
                    );
                    formData.append([`onsite[${key}][id]`], onsite[key]["id"]);
                }
            }
        } else {
            for (const key in pickUp) {
                if (
                    pickUp[key]["id"] ||
                    (pickUp[key]["service_order_number"] &&
                        pickUp[key]["date_completed"])
                ) {
                    formData.append(
                        [`pickup[${key}][service_order_number]`],
                        pickUp[key]["service_order_number"]
                    );
                    formData.append(
                        [`pickup[${key}][date_completed]`],
                        pickUp[key]["date_completed"]
                    );
                    formData.append(
                        [`pickup[${key}][remarks]`],
                        pickUp[key]["remarks"]
                    );
                    formData.append([`pickup[${key}][id]`], pickUp[key]["id"]);
                }
            }
        }
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return axiosV1.post(`warranty/update/service-history/${id}`, formData);
    },
};
